import './App.css';
import {Route, Routes} from "react-router-dom";
import Menu from "./components/menu/menu";
import React from "react";
import Home_page from "./components/home_pages/home_page";
// import ReactAudioPlayer from "react-audio-player";
// import audio from "./assets/Вальтер Гизекинг - Allegretto (Remastered 2022).mp3";

function App() {
    return (
        <>
            <Routes>
                <Route path={'/'} element={<Home_page/>}/>
                <Route path={'/menu'} element={<Menu/>}/>
            </Routes>
            {/*<audio autoPlay="autoPlay" loop>*/}
            {/*    <source src={audio} type="audio/ogg"/>*/}
            {/*    <source src={audio} type="audio/mpeg"/>*/}
            {/*</audio>*/}
            {/*<ReactAudioPlayer src={audio} autoPlay/>*/}
        </>
    );
}

export default App;
